import React, { useState } from "react";
import { ArrowDownOutlined, CheckCircleFilled, LockOutlined } from "@ant-design/icons";
import { Button, Empty, theme } from "antd";
import { DollarOutlined } from "@ant-design/icons";
import { OperationsHandoverPanel } from "../../../operations-v2/views/handover/OperationsHandoverPanel";
import { useQv4Theme } from "../../helpers";
import "./payment-handover-tab.css";
import { usePaymentsV2Query } from '../../../payments-v2/viewmodels/usePaymentsV2Query';
import PaymentsHeader, { proceedReason } from '../../../payments-v2/views/query-workspace/PaymentsHeader';

export function PaymentHandoverTab({ paymentProps, handoverProps, paymentVisible = false }) {
  const { t } = useQv4Theme();
  const { token } = theme.useToken();
  const payments = usePaymentsV2Query(handoverProps?.queryPk, { enabled: paymentVisible });
  const [handoverStatus, setHandoverStatus] = useState({ loading: true, eligible: false, state: null, reason: "Checking handover readiness…" });
  const ready = handoverStatus.eligible || handoverStatus.state === 'authorized';
  const blockedReason = payments.summary && !payments.summary.can_proceed ? proceedReason(payments.summary) : handoverStatus.reason;

  return (
    <div className="payment-handover-workflow">
      {paymentVisible && <section className="payment-handover-pane payment-handover-payment-pane" aria-label="Payments">
        <div className="payment-handover-section-heading" style={{ background: t.headerBg, borderColor: t.border }}>
          <div>
            <strong style={{ color: t.text }}>1. Payments</strong>
            <span style={{ color: t.textSub }}>Collect and verify the customer payment.</span>
          </div>
        </div>
        <div className="payment-handover-pane-content">
          {paymentProps?.onOpenPaymentModal ? (
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 10 }}>
              <span style={{ color: t.textSub, textAlign: "center" }}>Invoice, collections, settlement arrangements, and financial activity are managed in one Payments V2 workspace.</span>
              <Button type="primary" icon={<DollarOutlined />} onClick={paymentProps.onOpenPaymentModal}>Open Payments</Button>
            </div>
          ) : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Your access preset does not allow payment details." />}
          <div style={{ marginTop: 10 }}><PaymentsHeader summary={payments.summary} compact /></div>
        </div>
      </section>}

      <div
        className={`payment-handover-relationship ${ready ? "is-ready" : "is-blocked"}`}
        style={{
          "--relationship-bg": ready ? token.colorSuccessBg : t.headerBg,
          "--relationship-border": ready ? token.colorSuccessBorder : t.border,
          "--relationship-text": ready ? token.colorSuccessText : t.textSub,
        }}
        role="status"
      >
        <span className="payment-handover-relationship-line" />
        <span className="payment-handover-relationship-pill">
          {ready ? <CheckCircleFilled /> : <LockOutlined />}
          <span>{ready ? (handoverStatus.state === "authorized" ? "Operations handover complete" : "Ready for Operations handover") : blockedReason}</span>
          {!ready && <ArrowDownOutlined />}
        </span>
        <span className="payment-handover-relationship-line" />
      </div>

      <section className={`payment-handover-pane payment-handover-operations-pane ${ready ? "is-ready" : "is-blocked"}`} aria-label="Operations handover">
        <div className="payment-handover-section-heading" style={{ background: ready ? token.colorSuccessBg : t.headerBg, borderColor: ready ? token.colorSuccessBorder : t.border }}>
          <div>
            <strong style={{ color: ready ? token.colorSuccessText : t.textSub }}>{paymentVisible ? "2" : "1"}. Operations Handover</strong>
            <span style={{ color: t.textSub }}>{ready ? "Complete the transfer of responsibility to Operations." : "Complete the requirements below to enable handover."}</span>
          </div>
        </div>
        <div className="payment-handover-pane-content">
          <OperationsHandoverPanel {...handoverProps} embedded showFinancialSummary={!paymentVisible} onStatusChange={setHandoverStatus} />
        </div>
      </section>
    </div>
  );
}
